<script>
import DefaultBody from './job_body_default.vue'
import BasicBody from './job_body_basic.vue'
import BasicPlusBody from './job_body_basic_plus.vue'

import _get from 'lodash-es/get'

const TEMPLATE_MAPPING = {
  stellenanzeigeonlineadtemplate: BasicBody,
  stellenanzeigeonlineadliquidplus: BasicPlusBody,
  stellenanzeigeonlineadliquidbasic: BasicBody
}

export default {
  components: { DefaultBody, BasicBody, BasicPlusBody },
  props: { job: { type: Object, required: true } },
  render(createElement) {
    const template = _get(this.job, 'data.template')
    const component = TEMPLATE_MAPPING[template] || DefaultBody
    return createElement(component, { props: this.$props })
  }
}
</script>
